import { ImageRelevance } from "types";
import styles from "./style.module.scss";
import classNames from "classnames";
import { useEnrichmentCardContext } from "../../pages/DataPage/CardsView/DataList/EnrichmentCard/EnrichmentCardProvider";
import { useFeatureFlagService } from "../../../hooks/useFeatureFlagService";
import { VQL_UPGRADE } from "../../../helpers/constants/filters";

const RelevanceIcon = ({ relevance }: { relevance: ImageRelevance }) => {
  const { type, zone, score } = relevance!;
  const { enabled: isVQLUpgradeEnabled } = useFeatureFlagService(VQL_UPGRADE);
  const { isSingleItem } = useEnrichmentCardContext();
  const containerClassnames = classNames(styles.container, {
    [styles.h]: type === "High" || zone === "green",
    [styles.m]: type === "Medium" || zone === "yellow",
    [styles.l]: type === "Low" || zone === "red",
    [styles.small]: !isSingleItem,
  });

  return (
    <div className={containerClassnames}>
      <span className={styles.text}>
        {isVQLUpgradeEnabled ? <>{Math.floor(score * 100)}%</> : type}
      </span>
    </div>
  );
};

export default RelevanceIcon;
